
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FundFiatWithdrawalCreate } from 'types/fund-fiat-withdrawal-create';
import { FundProductWithdraw } from 'types/fund-product-withdraw';
import { FundWithdrawItem } from 'types/fund-withdraw-item';

interface FundsState {
  loading: boolean;
  fundsAction: string;
  pendingWithdrawFiatProducts: any[];
  pendingWithdrawCryptoProducts: any[];
  pendingWithdrawFiatProductsLoading: boolean;
  pendingWithdrawCryptoProductsLoading: boolean;
  withdrawInit: boolean;
  withdrawProducts: FundWithdrawItem[];
  withdrawProductsLoading: boolean;
  withdrawProduct: FundProductWithdraw;
  withdrawProductData: FundWithdrawItem;
  withdrawProductDataLoading: boolean;
  withdrawAmount: number | string;
  withdrawFee: number;
  withdrawAmountCrypto: number | string;
  withdrawCurrency: string;
  withdrawPendingData: FundFiatWithdrawalCreate;
  withdrawSuccess: boolean;
  withdrawValidToken: boolean;
  error: boolean;
  errorMessage: string;
}

const initialFundsState: FundsState = {
  loading: true,
  fundsAction: '',
  // Withdraw
  withdrawInit: false,
  pendingWithdrawFiatProducts: [],
  pendingWithdrawCryptoProducts: [],
  pendingWithdrawFiatProductsLoading: true,
  pendingWithdrawCryptoProductsLoading: true,
  withdrawProducts: [],
  withdrawProductsLoading: true,
  withdrawProduct: {},
  withdrawProductData: {},
  withdrawProductDataLoading: true,
  withdrawAmount: 0,
  withdrawFee: 0,
  withdrawAmountCrypto: 0,
  withdrawCurrency: '',
  withdrawPendingData: {},
  withdrawSuccess: false,
  withdrawValidToken: false,
  error: false,
  errorMessage: '',
};

const fund = createSlice({
  name: 'fund',
  initialState: initialFundsState,
  reducers: {
    setFundsLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setFundsAction(state, action: PayloadAction<string>) {
      state.fundsAction = action.payload;
    },
    setPendingWithdrawFiatProducts(state, action: PayloadAction<any[]>) {
      state.pendingWithdrawFiatProducts = action.payload;
    },
    setPendingWithdrawCryptoProducts(state, action: PayloadAction<any[]>) {
      state.pendingWithdrawCryptoProducts = action.payload;
    },
    setPendingWithdrawFiatProductsLoading(
      state,
      action: PayloadAction<boolean>,
    ) {
      state.pendingWithdrawFiatProductsLoading = action.payload;
    },
    setPendingWithdrawCryptoProductsLoading(
      state,
      action: PayloadAction<boolean>,
    ) {
      state.pendingWithdrawCryptoProductsLoading = action.payload;
    },
    setWithdrawInit(state, action: PayloadAction<boolean>) {
      state.withdrawInit = action.payload;
    },
    setWithdrawProducts(state, action: PayloadAction<FundWithdrawItem[]>) {
      state.withdrawProducts = action.payload;
    },
    setWithdrawProductsLoading(state, action: PayloadAction<boolean>) {
      state.withdrawProductsLoading = action.payload;
    },
    setWithdrawData(state, action: PayloadAction<FundProductWithdraw>) {
      state.withdrawProduct = action.payload;
    },
    setWithdrawProductData(state, action: PayloadAction<FundWithdrawItem>) {
      state.withdrawProductData = action.payload;
    },
    setWithdrawProductDataLoading(state, action: PayloadAction<boolean>) {
      state.withdrawProductDataLoading = action.payload;
    },
    setWithdrawAmount(state, action: PayloadAction<number | string>) {
      state.withdrawAmount = action.payload;
    },
    setWithdrawFee(state, action: PayloadAction<number>) {
      state.withdrawFee = action.payload;
    },
    setWithdrawAmountCrypto(state, action: PayloadAction<number | string>) {
      state.withdrawAmountCrypto = action.payload;
    },
    setWithdrawCurrency(state, action: PayloadAction<string>) {
      state.withdrawCurrency = action.payload;
    },
    setWithdrawPendingData(
      state,
      action: PayloadAction<FundFiatWithdrawalCreate>,
    ) {
      state.withdrawPendingData = action.payload;
    },
    setWithdrawSuccess(state, action: PayloadAction<boolean>) {
      state.withdrawSuccess = action.payload;
    },
    setError(state, action: PayloadAction<boolean>) {
      state.error = action.payload;
    },
    setErrorMessage(state, action: PayloadAction<string>) {
      state.errorMessage = action.payload;
    },
    setWithdrawValidToken(state, action: PayloadAction<boolean>) {
      state.withdrawValidToken = action.payload;
    },
    resetError(state) {
      state.errorMessage = '';
      state.error = false;
    },
  },
});

export const {
  setFundsLoading,
  setFundsAction,
  
  setPendingWithdrawFiatProducts,
  setPendingWithdrawCryptoProducts,
  setPendingWithdrawFiatProductsLoading,
  setPendingWithdrawCryptoProductsLoading,
  setWithdrawProducts,
  setWithdrawProductsLoading,
  setWithdrawData,
  setWithdrawProductData,
  setWithdrawProductDataLoading,
  setWithdrawAmount,
  setWithdrawFee,
  setWithdrawAmountCrypto,
  setWithdrawCurrency,
  setWithdrawPendingData,

  setError,
  setErrorMessage,
  setWithdrawValidToken,
  resetError,
} = fund.actions;

export default fund.reducer;
